"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVmax = exports.useVmin = exports.useVh = exports.useVw = exports.useViewportUnits = void 0;
var react_native_1 = require("react-native");
/**
 * allows use of vw and vh units for width and height
 * by creating functions that convert units to raw pixel values
 * returns separate functions - vw and vh - so vw can be used on height dimensions and vice-versa
 * also added vmax and vmin which scale units based on the greater or lesser of the two dimensions
 *
 * not using native useWindowDimensions hook to get updated window size because it is not supported in react-native-web
 */
exports.useViewportUnits = function () {
    var _a = react_native_1.Dimensions.get('window'), width = _a.width, height = _a.height; // useWindowDimensions();
    return {
        vw: function (units) { return units * width / 100; },
        vh: function (units) { return units * height / 100; },
        vmax: function (units) { return units * Math.max(width, height) / 100; },
        vmin: function (units) { return units * Math.min(width, height) / 100; },
    };
};
/**
 * also exporting the two separately for convenience
 * these hooks are themselves the converter, as they take the units as a param,
 * rather than returning a function
 */
exports.useVw = function (units) {
    return exports.useViewportUnits().vw(units);
};
exports.useVh = function (units) {
    return exports.useViewportUnits().vh(units);
};
exports.useVmin = function (units) {
    return exports.useViewportUnits().vmin(units);
};
exports.useVmax = function (units) {
    return exports.useViewportUnits().vmax(units);
};
//# sourceMappingURL=viewportSizing.js.map